var React = require('react');

function LockInline (props) {
    return React.createElement("path",props);
}

LockInline.defaultProps = {"fill":"#05050a","d":"M22,9.5v14H2v-14H22z M20.5,11h-17v11h17V11z M16.2,13.1l0.7,0.7l-5.5,5.3l-3.2-3.1l0.7-0.7l2.5,2.4L16.2,13.1z M12,0c4.4,0,8,3.6,8,8h-1.5c0-3.6-2.9-6.5-6.5-6.5S5.5,4.4,5.5,8H4C4,3.6,7.6,0,12,0z"};

module.exports = LockInline;

LockInline.default = LockInline;
